var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',_vm._g(_vm._b({staticClass:"cbs-select-number"},'el-select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.numberOptions),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }